import React from 'react';
import './confirm-modal.scss';
import { ChrModal } from '@chr/web-components';

export interface ConfirmModalProps {
  confirmResponse: () => void;
  cancelResponse: () => void;
  confirmLabel: string;
  cancelLabel: string;
  message: string;
  title: string;
}

export function ConfirmModal(props: ConfirmModalProps) {
  function confirmResponse() {
    props.cancelResponse();
    props.confirmResponse();
  }

  return (
    <div className="confirm-modal">
      <ChrModal closeAction={props.cancelResponse}>
        <header>
          <h1 className="modal-title">{props.title}</h1>
          <div>{props.message}</div>
        </header>
        <div className="cancelModalFooter">
          <button className="btn btn-primary" data-testid="confirmResponse" onClick={confirmResponse}>
            {props.confirmLabel}
          </button>
          &nbsp;&nbsp;
          <button className="btn btn-default" data-testid="cancelResponse" onClick={props.cancelResponse}>
            {props.cancelLabel}
          </button>
        </div>
      </ChrModal>
    </div>
  );
}
